import { useRef, useState, useEffect } from "react";
import { HomeBar, Landing, Overview, Feature, RoadMap, Team, ShowCase, Footer } from "./component";
// import IconLogo from "./assets/img/icon-logo.png";

const App = () => {
  const [offSetY, setOffSetY] = useState(0);
  const mainDiv = useRef();
  // const [pageReady, setPageReady] = useState(false);

  const handleScrolling = () => {
    if (!mainDiv.current.scrollTop) return;
    setOffSetY(mainDiv.current.scrollTop);
  }

  useEffect(() => {
    if (!mainDiv.current) return;
    mainDiv.current.addEventListener('scroll', handleScrolling);

    return () => mainDiv.current.removeEventListener('scroll', handleScrolling);
  });

  // useEffect(() => {
  //   document.onreadystatechange = () => {
  //     if (document.readyState === 'complete') {
  //       setPageReady(true);
  //     }
  //   };
  // })

  const handleScroll = (e) => {
    let target_id = e.target.getAttribute('data-target');
    let target = document.querySelector(`#${target_id}`);
    target.scrollIntoView({behavior: "smooth"});
  }

  return (
    <>
      <div className="h-full overflow-x-hidden overflow-y-scroll relative" ref={(e) => mainDiv.current=e}>
        <HomeBar onScroll={(e) => handleScroll(e)} scrollY={offSetY}  />
        <Landing />
        <Overview />
        <Feature />
        <RoadMap />
        <ShowCase />
        <Team />
        <Footer />
      </div>
      {/* <div className={`${pageReady?'hidden ':''}absolute w-full h-full top-0 bg-[#FFF] z-[9999999999999999] flex justify-center items-center`}>
        <div className="animate-ltr-l absolute bg-[rgba(1,194,240,0.2)] blur-[1000px] left-[-461px] top-[-20px] w-full h-full z-0"></div>
        <div className="animate-rtl-l absolute bg-[rgba(15,216,138,0.2)] blur-[1000px] right-[-230px] top-[-20px] w-full h-full z-0"></div>
        <img src={IconLogo} alt="icon-logo" className="App-logo z-10 w-[80px]" />    
      </div> */}
    </>
  );
}

export default App;
